<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Perfil"
              v-model="form.filters.nome"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sigfoco-select-ativo
            :cols="3"
            v-model="form.filters.situacao"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarPerfis()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterPerfil()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listPerfis"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarPerfil(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterPerfil(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="'Excluir'"
            :icon="'mdi-delete'"
            :small="true"
            @click="excluirPerfil(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.situacao ? 'var(--primary-button-color)' : 'silver'}`"
            :small="true"
            @click="inativarAtivarPerfil(item)"
          ></sigfoco-tooltip>
        </template>
        <template v-slot:[`item.emUso`]="{ item }">
          <sigfoco-tooltip
            :text="'Detalhar Uso'"
            :icon="item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"
            :color="item.emUso ? 'green' : 'red'"
            :small="true"
            :disabled="!item.emUso"
            @click="item.emUso ? openDialogDetalharUsoPerfil(item) : null"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarPerfilDialog
      :visible="dialogManterPerfil.visible"
      :content="dialogManterPerfil.content"
      :edit="dialogManterPerfil.edit"
      @onClose="dialogManterPerfil.close()"
      @onSave="buscarPerfis()"
    ></CadastrarEditarPerfilDialog>
    <VisualizarPerfilDialog
      :visible="dialogVisualizarPerfil.visible"
      :content="dialogVisualizarPerfil.content"
      @onClose="dialogVisualizarPerfil.close()"
    ></VisualizarPerfilDialog>
      <DetalharUsoPerfilDialog
      :visible="dialogDetalharUsoPerfil.visible"
      :content="dialogDetalharUsoPerfil.content"
      @onClose="dialogDetalharUsoPerfil.close()"
    ></DetalharUsoPerfilDialog>
  </div>
</template>

<script>
import { Dialog } from "~/commons/classes/dialog";
import { Perfil } from "~/commons/classes/perfil";
import ManterPerfilService from "~/services/manter-perfil.service";
import CadastrarEditarPerfilDialog from "./dialogs/CadastrarEditarPerfilDialog.vue";
import VisualizarPerfilDialog from "./dialogs/VisualizarPerfilDialog.vue";
import DetalharUsoPerfilDialog from "./dialogs/DetalharUsoPerfilDialog.vue";

export default {
  name: "ManterPerfilView",
  mixins: [ManterPerfilService],
  components: {
    CadastrarEditarPerfilDialog,
    VisualizarPerfilDialog,
    DetalharUsoPerfilDialog,
  },
  data: () => ({
    dialogManterPerfil: Dialog.Build(),
    dialogVisualizarPerfil: Dialog.Build(),
    dialogDetalharUsoPerfil: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        situacao: null,
      },
      lists: {
        listPerfis: []
      }
    },
    headers: [
      { text: "Perfil", align: "center", value: "nome" },
      { text: "Situação", align: "center", value: "situacao" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
      { text: "Em uso", align: "center", value: "emUso", sortable: false },
    ]
  }),
  methods: {
    openDialogManterPerfil(perfil) {
      perfil
        ? this.$visualizarPerfil(perfil).then(({ data }) => {
            this.dialogManterPerfil.open(new Perfil(data.resposta), true);
          })
        : this.dialogManterPerfil.open(Perfil.Build());
    },
    openDialogVisualizarPerfil(perfil) {
      this.$visualizarPerfil(perfil).then(
        ({ data }) => (this.dialogVisualizarPerfil.open(data.resposta))
      );
    },
    openDialogDetalharUsoPerfil(perfil) {
      this.$detalharUsoPerfil(perfil).then(
        ({ data }) => (this.dialogDetalharUsoPerfil.open(data.resposta))
      );
    },
    buscarPerfis() {
      this.$buscarPerfis({ params: this.form.filters }).then(
        ({ data }) => (this.form.lists.listPerfis = data.lista)
      );
    },
    inativarAtivarPerfil(perfil) {
      this.$swal({
        text: `Deseja confirmar a ${ perfil.situacao ? "inativação" : "ativação" } do Perfil?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        if (perfil.emUso) {
          this.mostrarModalEmUso();
        } else {
        this.$inativarAtivarPerfil(
          { id: perfil.id },
          perfil.id
        ).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarPerfis();
        });
      }
      });
    },
excluirPerfil(perfil) {
    this.$swal({
      text: `Deseja confirmar a exclusão do perfil?`,
      type: "error",
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`,
    }).then(() => {
        if (perfil.emUso) {
          this.mostrarModalEmUso();
        } else {
          this.$excluirPerfil(
            { id: perfil.id },
            perfil.id
          ).then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarPerfis();
          });
        }
    });
  },
    resetForm() {
      this.$resetForm();
      this.form.lists.listPerfis = [];
      this.form.filters.situacao = null;
    },
    mostrarModalEmUso() {
      this.$swal({
      text: "O registro não pode ser inativado ou excluído, pois está em uso em outra(s) funcionalidade(s).",
      type: "warning",
      confirmButtonText: `OK`,
    });
  }
  },
};
</script>
<style scoped>
.abas {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.aba {
  padding-right: 0.5em;
}
</style>
